import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { Condition } from 'Component/others';
import useGetHostScheduleDetail from 'Domain/host/useGetHostScheduleDetail';
import useGetTotalRequestReschedule from 'Domain/reschedule/useGetTotalRequestReschedule';
import { TextMedium, TextRegular } from 'UiKit/typography';
import { AlertOutlineIcon } from 'Asset/icon';

import RescheduleBadgeStatus from 'View/reschedule-form/component/reschedule-badge-status';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

const RescheduleInfo = () => {
  const { t } = useTranslation('host-schedule', 'host-reschedule');
  const navigate = useNavigate();
  const { data, isFetching, isError, error } = useGetHostScheduleDetail();
  const { data: dataTotalRequest, isFetching: isFetchingTotal } = useGetTotalRequestReschedule();

  if (isError && error?.status === 403) navigate('/forbidden-schedule');

  const isQuotaExist = dataTotalRequest?.remaining > 0;
  const alertQuotaText = isQuotaExist
    ? t('host-reschedule:remaining_opportunities', { remaining: dataTotalRequest?.remaining, total: dataTotalRequest?.maxRequest })
    : t('host-reschedule:quota_exhausted');
  const isRescheduleApproved = data?.reschedule?.statusProgress === 'Diterima';
  const isShowAlert = data?.isCanRequestReschedule && data?.reschedule?.statusProgress !== 'Diproses';

  return (
    <Condition statement={!isFetching && !isFetchingTotal}>
      <Condition statement={data?.hasReschedule}>
        <Box className={styles['reschedule-info__container']}>
          <Box className={styles['reschedule-info__title-status--container']}>
            <TextRegular className={styles['reschedule-info__title--text']}>{t('reschedule_info.title')}</TextRegular>
            <Condition statement={!isRescheduleApproved}>
              <RescheduleBadgeStatus status={data?.reschedule?.statusProgress} />
            </Condition>
          </Box>
          <Box className={styles['reschedule-info__field-container']}>
            <TextRegular className={styles['reschedule-info__field-label']}>{t('reschedule_info.approval_type')}</TextRegular>
            <TextMedium className={styles['reschedule-info__field-value']}>{data?.reschedule?.rescheduleType}</TextMedium>
          </Box>
          <Box className={styles['reschedule-info__field-container']}>
            <TextRegular className={styles['reschedule-info__field-label']}>{t('reschedule_info.replacement_schedule')}</TextRegular>
            <TextMedium className={styles['reschedule-info__field-value']}>{data?.reschedule?.label}</TextMedium>
          </Box>
          <Box className={styles['reschedule-info__field-container']}>
            <TextRegular className={styles['reschedule-info__field-label']}>{t('reschedule_info.replacement_host')}</TextRegular>
            <TextMedium className={styles['reschedule-info__field-value']}>{data?.reschedule?.targetUser}</TextMedium>
          </Box>
        </Box>
      </Condition>

      <Condition statement={isShowAlert}>
        <Box className={`${dataTotalRequest?.remaining < 2 ? styles['reschedule-chance__container--error'] : ''} ${styles['reschedule-chance__container']}`}>
          <AlertOutlineIcon color={dataTotalRequest?.remaining > 1 ? 'var(--color-neutral70)' : 'var(--color-error50)'} size={11} />
          <TextRegular
            className={`${styles['reschedule-chance__max-chance--text']} ${dataTotalRequest?.remaining < 2 && styles['reschedule-chance__no-request-text']}`}
          >
            {alertQuotaText}
          </TextRegular>
        </Box>
      </Condition>
    </Condition>
  );
};

export default RescheduleInfo;
